document.addEventListener('DOMContentLoaded', function () {
  initAvxReveal();
  initAvxCountUp();
  initAvxResenas();
});

function initAvxResenas() {
  document.querySelectorAll('[data-avx-resenas]').forEach(function (root) {
    var toggle = root.querySelector('[data-avx-resenas-toggle]');
    if (!toggle) return;
    var ocultas = root.querySelectorAll('.avx-resena--oculta');
    var expandido = false;
    toggle.addEventListener('click', function () {
      expandido = !expandido;
      ocultas.forEach(function (el) {
        el.classList.toggle('avx-resena--oculta', !expandido);
      });
      var label = toggle.querySelector('span');
      var texto = expandido ? toggle.getAttribute('data-texto-menos') : toggle.getAttribute('data-texto-mas');
      if (label && texto) label.textContent = texto;
    });
  });
}

function initAvxReveal() {
  var els = document.querySelectorAll('.avx-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('avx-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('avx-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initAvxCountUp() {
  var els = document.querySelectorAll('[data-avx-countup]');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var target = parseFloat(el.getAttribute('data-avx-countup'));
      var decimals = (el.getAttribute('data-avx-countup').split('.')[1] || '').length;
      var duration = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = (target * eased).toFixed(decimals);
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(decimals);
      }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { observer.observe(el); });
}
